import { render, staticRenderFns } from "./Prouduct.vue?vue&type=template&id=52305b86&"
import script from "./Prouduct.vue?vue&type=script&lang=js&"
export * from "./Prouduct.vue?vue&type=script&lang=js&"
import style0 from "./Prouduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports